import { Directive, Input } from "@angular/core";
import { NotificationService } from "@app/core/services/notification.service";
import { ClientUserUriBuilderParams, UserService } from "@app/core/services/user.service";
import { Client } from "@app/shared/models/client";
import { AuthenticationMethod, ClientUser } from "@app/shared/models/client-user";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { TwoWayBoundComponent } from "../../base/two-way-bound.component";

@Directive()
export abstract class User2FAComponentBase extends TwoWayBoundComponent<ClientUser> {
    
    @Input()
    protected client: Client;

    get user(): ClientUser {
        return this.bananaBox;
    }

    get AuthenticationMethods() {
        return AuthenticationMethod;
    }

    constructor(
        protected userService: UserService, 
        protected notificationService: NotificationService) {
        super();
    }

    protected abstract resetInternal();

    public reset(method: AuthenticationMethod): void {
        const uriBuilder = new ClientUserUriBuilderParams(this.client, this.user);

        this.notificationService.showSimpleConfirmDialog(
            marker('user_management.2fa.dialog.reset.title'),
            marker('user_management.2fa.dialog.reset.text.'+method),
        ).subscribe(result => {
            if (result) {
                this.user.authentication_sms_verified = false;
                this.user.authentication_totp_verified = false;
                this.userService.update(uriBuilder, this.user).subscribe(_ => {
                    this.resetInternal();
                })
            }
        });
    }

    public verifyOTP(method: AuthenticationMethod, code: string): void {
        const uriBuilder = new ClientUserUriBuilderParams(this.client, this.user);

        this.userService.verifyTwoFACode(uriBuilder, method, code).subscribe(result => {
            if (result.data) {
                if (method === AuthenticationMethod.SMS) {
                    this.user.authentication_sms_verified = true;
                } else if (method === AuthenticationMethod.TOTP) {
                    this.user.authentication_totp_verified = true;
                }
            } else {
                this.notificationService.showSimpleErrorSnackbar(
                    marker('user_management.2fa.error.invalid_tan')
                );
            }
        });
    }
}
